module.exports = __webpack_public_path__ + "static/img/img.75a80673.png";